var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThincross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.139,
    height: 27.087,
    viewBox: "0 0 26.139 27.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    transform: "translate(2816.241 3971.536)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_3863",
    "data-name": "Line 3863",
    x2: 25.572,
    y2: 26.541,
    transform: "translate(-2815.957 -3971.263)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 0.787
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3864",
    "data-name": "Line 3864",
    x1: 25.572,
    y2: 26.541,
    transform: "translate(-2815.957 -3971.263)",
    fill: "none",
    stroke: "#040505",
    strokeMiterlimit: 10,
    strokeWidth: 0.787
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThincross);
export default __webpack_public_path__ + "static/media/thincross.74460e0e44ae42f2cb2f057bd04eaf5a.svg";
export { ForwardRef as ReactComponent };